import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";
import { useCallback, useMemo, useState } from "react";

export function useDeepDirtyBaseline<T>({
  open,
  currentValues,
}: {
  open: boolean;
  currentValues: T;
}) {
  const [baseline, setBaseline] = useState<T | null>(null);

  const isDirty = useMemo(() => {
    if (!open || baseline == null) {
      return false;
    }
    return !isEqual(currentValues, baseline);
  }, [baseline, currentValues, open]);

  const setBaselineSnapshot = useCallback((nextBaseline: T) => {
    setBaseline(cloneDeep(nextBaseline));
  }, []);

  const clearBaseline = useCallback(() => {
    setBaseline(null);
  }, []);

  return {
    isDirty,
    hasBaseline: baseline != null,
    setBaselineSnapshot,
    clearBaseline,
  };
}
